import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { clearNotifications, deleteIcon, fetchIcons, selectIcon } from 'app/actions/manage-icons.actions';
import { errors, notifications } from 'app/resources/manage-icons.api';

const DIRTY_FORM = 'widgetsManagement';

const mapStateToThis = (state) => ({
  icons: state.manageIcons.entries,
  isLoading: state.manageIcons.isLoading,
  locale: state.session.locale,
});

const mapDispatchToThis = {
  setDirtyForm,
  fetchIcons,
  selectIcon,
  deleteIcon,
  clearNotifications
};

@Inject('$ngRedux', 'gettextCatalog', 'Notifications')
export class ManageIconsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.errors = errors;
    this.notifications = notifications;
    this.fetchIcons();
  }

  $onDestroy() {
    this.clearNotifications();
    this.unsubscribe();
  }

  deleteIconChanges(icon) {
    this.setDirtyForm(DIRTY_FORM, true);
    return this.deleteIcon(icon);
  }

  $onChanges(changes) {
    const { error, notification } = changes;

    if (error && error.currentValue !== '') {
      const givenErrorCode = error.currentValue;
      const errorMsg = this.errors.find((error) => error.code === givenErrorCode);

      this.Notifications.alertError(errorMsg.text());
    }

    if (notification && notification.currentValue !== '') {
      if (notification.currentValue !== 'ICON_DISCARD_SUCCESS') {
        this.setDirtyForm(DIRTY_FORM, true);
      }
      const givenNotificationCode = notification.currentValue;
      const notificationMsg = this.notifications.find((notification) => notification.code === givenNotificationCode);

      this.Notifications.alertSuccess(notificationMsg.text());
    }
  }

  onFileChange($event) {
    const file = $event.target.files[0];

    this.selectIcon(file, {
      accept: ['.jpg', '.jpeg', '.png', '.gif']
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/manage-icons/manage-icons-controller.js